import { render, staticRenderFns } from "./PurchasesManagement.vue?vue&type=template&id=89d0a882&scoped=true"
import script from "./PurchasesManagement.vue?vue&type=script&lang=js"
export * from "./PurchasesManagement.vue?vue&type=script&lang=js"
import style0 from "./PurchasesManagement.vue?vue&type=style&index=0&id=89d0a882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d0a882",
  null
  
)

export default component.exports